import { useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Home() {
  useEffect(() => {
    const ping = async () => {
      try {
        const r = await axios.get(`${API}/`);
        // eslint-disable-next-line no-console
        console.log("Backend ready:", r.data?.message);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("API not reachable", e);
      }
    };
    ping();
  }, []);

  return (
    <div>
      {/* Hero */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_20%_10%,#ffe8cc,transparent_40%),radial-gradient(circle_at_80%_0%,#ffd2a1,transparent_35%),linear-gradient(to_bottom,#fff,#fff)]"></div>
        <div className="max-w-6xl mx-auto px-4 py-16 md:py-24">
          <div className="grid gap-10 items-center">
            <div>
              <h1 className="text-4xl md:text-5xl font-black tracking-tight text-slate-900">
                Une école primaire active spécialisée
              </h1>
              <p className="mt-4 text-lg text-slate-700">
                Dans une classe coopérative, inspirée par la Pédagogie Freinet et la Pédagogie Institutionnelle,
                nombreuses sont les institutions qui jouent le rôle de médiation.
              </p>
              <div className="mt-6 flex gap-3">
                <a href="#ceintures" className="px-4 py-2 rounded-full bg-amber-500 text-white font-semibold shadow-sm hover:bg-amber-600">Découvrir nos ceintures</a>
                <a href="#conseil" className="px-4 py-2 rounded-full border border-amber-300 text-amber-800 font-semibold hover:bg-orange-100">Le conseil</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Écoquartier */}
      <section className="max-w-6xl mx-auto px-4 py-12">
        <div className="grid gap-6">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-slate-900">Écoquartier des Vergers</h2>
            <p className="mt-3 text-slate-700">
              La Voie Lactée se trouve dans l'écoquartier des Vergers et fait partie des 4 bâtiments de l'équipement public
              avec l'école primaire régulière, la salle de gymnastique et le parascolaire.
            </p>
            <a href="/historique" className="mt-4 inline-block text-amber-700 font-semibold hover:underline">En savoir plus</a>
          </div>
        </div>
      </section>

      {/* Ceintures de niveau */}
      <section id="ceintures" className="bg-gradient-to-br from-orange-50 to-amber-50 border-y border-orange-100">
        <div className="max-w-6xl mx-auto px-4 py-12">
          <div className="grid gap-6">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-slate-900">Ceintures de niveau</h2>
              <p className="mt-3 text-slate-700">
                Le programme de l'école primaire genevoise pour chaque matière a été découpé en niveaux, comprenant
                chacun quelques critères, dont l'ensemble constitue une ceinture de couleur représentant un certain niveau de compétence.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Conseil */}
      <section id="conseil" className="max-w-6xl mx-auto px-4 py-12">
        <div className="grid gap-6 items-center">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-slate-900">Le conseil</h2>
            <p className="mt-3 text-slate-700">
              Dans une classe « coopérative », inspirée par la Pédagogie Freinet et la Pédagogie Institutionnelle,
              nombreuses sont les institutions qui jouent le rôle de médiation. Par médiation, nous entendons tout
              élément qui introduit du tiers entre l'élève et l'enseignant, permettant une construction d'autonomie à la
              place d'une dépendance, ou d'une relation fusionnelle.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
